import {ReactComponent as DuoRequiredInfo} from '../../assets/icons/DuoRequiredInfo.svg'
const StyledRequireText = () => {
    return (
        <div
            className="border-1 px-1 border-round-sm mb-1"
            style={{background: '#fef2f2', borderColor: '#fef2f2'}}>
            <span
                className="flex text-sm align-items-center gap-1 font-semibold bg-red-50 white-space-nowrap"
                style={{
                    color: 'red',
                }}>
                {' '}
                <DuoRequiredInfo height={20} width={20} />
                This field is required !
            </span>{' '}
        </div>
    )
}

export default StyledRequireText
